module.exports = __webpack_public_path__ + "img/computer.83f5ee34.gif";